var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled, { css } from "styled-components";
import { getColor, getSizeBy, DefaultTheme, DarkTheme } from "../../theme";
import margin from "../../mixins/margin";
import padding from "../../mixins/padding";
import alignSelf from "../../mixins/alignSelf";
import textTransform from "../../mixins/textTransform";
import { DEFAULT, HOLLOW, BORDER_LESS } from "./constants";
var themes = {
    light: DefaultTheme,
    dark: DarkTheme,
};
var activeStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n"], ["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n"])), function (props) { return props.colors.borderActive(props); }, function (props) { return props.colors.bgActive(props); }, function (props) { return props.colors.colorActive(props); });
var withTheme = function (props) {
    if (props.themeType) {
        return __assign(__assign({}, props), { theme: themes[props.themeType] });
    }
    return __assign(__assign({}, props), { theme: props.theme });
};
var getPrimaryColor = function (props) {
    return props.neutral ? getColor("text")(props) : getColor("primary")(props);
};
var getBorderColor = function (props) {
    return props.neutral ? getColor("border")(props) : getColor("primary")(props);
};
var getTextColor = getColor("bright");
var getHoverColor = function (props) {
    return props.neutral ? getColor("textFocus")(props) : getColor("accent")(props);
};
var getAccentColor = function (props) {
    return props.neutral ? getColor("textFocus")(props) : getColor("successLite")(props);
};
var getMain = function (props) {
    return props.neutral
        ? getColor(props.disabled ? "disabled" : "mainBackground")(props)
        : getColor("mainBackground")(props);
};
var getTransparent = getColor(["transparent", "full"]);
var colorsByFlavour = function (_a) {
    var _b;
    var _c = _a.flavour, flavour = _c === void 0 ? DEFAULT : _c, danger = _a.danger, warning = _a.warning;
    var getErrorColor = danger ? getColor("error") : undefined;
    var getWarningColor = warning ? getColor("warning") : undefined;
    var getSpecialColor = getErrorColor || getWarningColor;
    var flavours = (_b = {},
        _b[DEFAULT] = {
            color: getTextColor,
            colorHover: getTextColor,
            colorActive: getTextColor,
            bg: getSpecialColor || getPrimaryColor,
            bgHover: getSpecialColor || getHoverColor,
            bgActive: getSpecialColor || getAccentColor,
            border: getSpecialColor || getPrimaryColor,
            borderHover: getSpecialColor || getHoverColor,
            borderActive: getSpecialColor || getAccentColor,
        },
        _b[HOLLOW] = {
            color: getSpecialColor || getPrimaryColor,
            colorHover: getSpecialColor || getAccentColor,
            colorActive: getSpecialColor || getAccentColor,
            bg: getTransparent,
            bgHover: getTransparent,
            bgActive: getSpecialColor || getMain,
            border: getSpecialColor || getBorderColor,
            borderHover: getSpecialColor || getHoverColor,
            borderActive: getSpecialColor || getAccentColor,
        },
        _b[BORDER_LESS] = {
            color: getSpecialColor || getPrimaryColor,
            colorHover: getSpecialColor || getAccentColor,
            colorActive: getSpecialColor || getAccentColor,
            bg: getTransparent,
            bgHover: getTransparent,
            bgActive: getTransparent,
            border: getTransparent,
            borderHover: getTransparent,
            borderActive: getTransparent,
        },
        _b);
    return flavours[flavour] || flavours[DEFAULT];
};
export var StyledButton = styled.button.attrs(function (props) { return (__assign({ padding: props.padding || [2], colors: colorsByFlavour(props) }, withTheme(props))); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    ", ";\n\n    width: ", ";\n    height: ", ";\n\n    font-weight: 500;\n    font-size: ", ";\n    line-height: ", ";\n    white-space: nowrap;\n    word-break: keep-all;\n\n    cursor: pointer;\n    opacity: ", ";\n    pointer-events: ", ";\n\n    ", "\n    ", "\n    transition: all 150ms;\n\n    background-color: ", ";\n    color: ", ";\n\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n\n    text-decoration: none;\n    & > span {\n      ", ";\n      margin-left: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n      text-decoration: none;\n\n      .button-icon {\n        fill: ", ";\n      }\n    }\n\n    &:active {\n      ", "\n    }\n    ", "\n\n    &:focus {\n      outline: none;\n    }\n\n    .button-icon {\n      height: ", ";\n      width: ", ";\n      fill: ", ";\n    }\n\n    .ntd-spinner {\n      fill: none;\n      stroke-width: 17px;\n      stroke-dasharray: 100;\n      stroke-dashoffset: 100;\n      animation: ntd-draw 1s linear infinite;\n      stroke: ", ";\n      width: 24px;\n    }\n\n    .path {\n      stroke: ", ";\n    }\n\n    @keyframes ntd-draw {\n      to {\n        stroke-dashoffset: 0;\n      }\n    }\n  }\n"], ["\n  && {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    ", ";\n\n    width: ", ";\n    height: ", ";\n\n    font-weight: 500;\n    font-size: ", ";\n    line-height: ", ";\n    white-space: nowrap;\n    word-break: keep-all;\n\n    cursor: pointer;\n    opacity: ", ";\n    pointer-events: ", ";\n\n    ", "\n    ", "\n    transition: all 150ms;\n\n    background-color: ", ";\n    color: ", ";\n\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n\n    text-decoration: none;\n    & > span {\n      ", ";\n      margin-left: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n      text-decoration: none;\n\n      .button-icon {\n        fill: ", ";\n      }\n    }\n\n    &:active {\n      ", "\n    }\n    ", "\n\n    &:focus {\n      outline: none;\n    }\n\n    .button-icon {\n      height: ", ";\n      width: ", ";\n      fill: ", ";\n    }\n\n    .ntd-spinner {\n      fill: none;\n      stroke-width: 17px;\n      stroke-dasharray: 100;\n      stroke-dashoffset: 100;\n      animation: ntd-draw 1s linear infinite;\n      stroke: ", ";\n      width: 24px;\n    }\n\n    .path {\n      stroke: ", ";\n    }\n\n    @keyframes ntd-draw {\n      to {\n        stroke-dashoffset: 0;\n      }\n    }\n  }\n"])), alignSelf, function (props) {
    return props.width ? props.width : props.hasLabel ? getSizeBy(16) : getSizeBy(props.tiny ? 2.75 : props.small ? 3 : 4);
}, function (props) {
    return props.hasLabel ? getSizeBy(props.small ? 4 : 5) : getSizeBy(props.tiny ? 2.75 : props.small ? 3 : 4);
}, function (_a) {
    var small = _a.small, tiny = _a.tiny;
    return (tiny ? "10px" : small ? "12px" : "14px");
}, getSizeBy(2), function (_a) {
    var disabled = _a.disabled, neutral = _a.neutral;
    if (neutral)
        return 1;
    return disabled ? 0.4 : 1;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "none" : "auto");
}, margin, padding, function (props) { return props.colors.bg(props); }, function (props) { return props.colors.color(props); }, function (props) { return props.colors.border(props); }, textTransform, function (_a) {
    var hasIcon = _a.hasIcon;
    return (hasIcon ? getSizeBy(1.5) : "0px");
}, function (props) { return props.colors.borderHover(props); }, function (props) { return props.colors.bgHover(props); }, function (props) { return props.colors.colorHover(props); }, function (props) { return props.colors.colorHover(props); }, activeStyles, function (props) {
    return props.active &&
        "\n      ".concat(activeStyles, "\n    ");
}, getSizeBy(2), getSizeBy(2), function (props) { return props.colors.color(props); }, function (props) { return props.colors.color(props); }, function (props) { return props.colors.color(props); });
var templateObject_1, templateObject_2;
